module.exports = __webpack_public_path__ + "img/Logo-24.b055d4a0.svg";